module.exports = __webpack_public_path__ + "static/media/hosting-setup.5b2bf98a.png";